import { Injectable } from '@angular/core';
import { DatasourceService } from './datasource.service';
import { State } from '@progress/kendo-data-query'; 
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { User } from '@app/core/models';

@Injectable({ providedIn: 'root' })
export class AuthService {

    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private router: Router, protected service : DatasourceService, private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem(environment.appName + '-currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string) {

        let state : State = {
            // skip: 0, 
            take: 1,
            sort: [], 
            filter: {
                logic: "and",
                filters: [{
                    field: 'user',
                    operator: 'eq',
                    value: username
                },{
                    field: 'password',
                    operator: 'eq',
                    value: password
                }]
            }, 
            //group: []
        }
        return this.http.post<any>(`${environment.apiUrl}/api/users/search`, state)
            .pipe(map(res => {
                let user : User = res.data[0];
                // console.log(user)
                if (user /*&& user.token*/) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes

                    this.permissions(user.id_role)
                        .subscribe(
                            permissions => {
                                user.permissions = [];
                                for (let permission of permissions) {
                                    user.permissions.push(permission.permission_action)
                                }

                                localStorage.setItem(environment.appName + '-currentUser', JSON.stringify(user));
                                this.currentUserSubject.next(user);
                                this.router.navigate(['/']);
                            },
                            error => {
                                console.log(error)
                                // this.loading = false;
                            });                    

                }
                return user;
            }));
            
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem(environment.appName + '-currentUser');
        this.currentUserSubject.next(null);
        this.router.navigate(['/login']);
    }

    permissions(id_rol: number) {

        let state : State = {
            // skip: 0, 
            take: 0,
            sort: [], 
            filter: {
                logic: "and",
                filters: [{
                    field: 'id_role',
                    operator: 'eq',
                    value: id_rol
                }]
            }, 
            //group: []
        }
        return this.http.post<any>(`${environment.apiUrl}/api/permissions_roles/search`, state)
            .pipe(map(res => {
                return res.data;
            }));

    }

    hasPermission(permissions: string[]){

        let user = this.currentUserSubject.value;
        
        let res = []
        for (let p of permissions) {
            let index = user.permissions.findIndex(x => x === p) != -1;
            res.push(index)
        }

        return res.reduce((a, b) => a || b, false);

    }

    hasAccess(permissions: string[]){

        let user = this.currentUserSubject.value;

        let res = []
        for (let p of permissions) {
            let found = user.permissions.filter(x => x.includes(p)).length != 0 ;
            res.push(found)
        }
        
        return res.reduce((a, b) => a || b, false);

    }


}